var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory10 = function SvgCategory10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category10_svg__w-full category10_svg__h-full",
    viewBox: "0 0 36 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M18.016 1.683q.436-.002.864.1l13.303 3.076h.032l.141.069c1.17.559 1.916 1.668 1.916 2.877v16.797c0 4.193-2.199 8.188-5.882 10.682l-10.382 7.01-10.382-7.01c-3.684-2.502-5.89-6.496-5.89-10.69V7.813c0-1.27.824-2.434 2.073-2.946h.023l13.296-3.084c.29-.069.59-.1.888-.1m0-1.683a6 6 0 0 0-1.272.138L3.4 3.222a1.5 1.5 0 0 0-.244.076C1.241 4.086 0 5.846 0 7.813v16.781c0 4.744 2.482 9.26 6.628 12.068l10.453 7.055c.275.191.597.283.919.283s.644-.092.919-.283l10.453-7.055C33.518 33.846 36 29.338 36 24.594V7.798c0-1.952-1.24-3.727-3.165-4.508l.016.016s-.165-.061-.244-.077L19.272.138A5.8 5.8 0 0 0 18.016 0"
  })));
};
export default SvgCategory10;